import { render, staticRenderFns } from "./selected-criterion-numeric.vue?vue&type=template&id=2b46410c&scoped=true&"
import script from "./selected-criterion-numeric.vue?vue&type=script&lang=js&"
export * from "./selected-criterion-numeric.vue?vue&type=script&lang=js&"
import style0 from "./selected-criterion-numeric.vue?vue&type=style&index=0&id=2b46410c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b46410c",
  null
  
)

export default component.exports